"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Get `srcset` size.
 */
var getSrcsetSize = function getSrcsetSize(baseWidth) {
  return function (dpi) {
    return isNaN(baseWidth) ? "".concat(dpi, "x") : "".concat(Number(baseWidth) * dpi, "w");
  };
};
/**
 * `StyledImage` styled component.
 */


var StyledImage = _styledComponents.default.img.withConfig({
  displayName: "image__StyledImage",
  componentId: "sp2knt-0"
})(["display:inline-block;height:auto;max-width:", ";"], (0, _styledTools.prop)('maxWidth', '100%'));
/**
 * Export `Image` component.
 */


var Image = function Image(props) {
  var baseWidth = props.baseWidth,
      defaultUrl = props.defaultUrl,
      retinaUrl = props.retinaUrl,
      rest = _objectWithoutProperties(props, ["baseWidth", "defaultUrl", "retinaUrl"]);

  var setSize = getSrcsetSize(baseWidth);
  var srcSet = retinaUrl ? {
    srcSet: "".concat(defaultUrl, " ").concat(setSize(1), ", ").concat(retinaUrl, " ").concat(setSize(2))
  } : {};
  return _react.default.createElement(StyledImage, _extends({}, rest, srcSet, {
    src: defaultUrl
  }));
};

exports.Image = Image;